import { DefaultTheme, keyframes } from 'styled-components';

const defaultTheme: DefaultTheme = {
  colors: {
    BG: '#f8fcff',
    BG1: '#F1F8FF',
    BG_SPLASH: '#D5DDE9',
    TITLE: '#404851',
    LABEL: '#78828C',
    CARD: '#FFFFFF',
    BORDER: '#EDEFF2',
    BLUE: {
      B500: '#0655C8',
      B400: '#206FE2',
      B350: '#5197ff',
      B200: '#86D5FF',
      B100: '#F8FCFF',
      B50: '#f8faff',
    },
    NEUTRAL: {
      N900: '#101840',
      N800: '#474D66',
      N700: '#696F8C',
      N600: '#8F95B2',
      N500: '#C1C4D6',
      N400: '#D8DAE5',
      N300: '#E6E8F0',
      N200: '#EDEFF5',
      N100: '#F4F6FA',
      N75: '#F9FAFC',
      N50: '#FAFBFF',
      N0: '#FFFFFF',
    },
    GREEN: {
      G400: '#52BD94',
    },
    RED: {
      R500: '#d21828',
      R400: '#FF1D31',
    },
    ORANGE: {
      O500: '#d98941',
      O400: '#EB9447',
    },
    //
    NOTIFICATION_FEEDBACK: '#6e62b6',
    NOTIFICATION_RE_CONTACT: '#206FE2',
    NOTIFICATION_UPCOMING_INTERVIEW: '#EB9447',

    STATUSES_GREY: '#808080',
    STATUSES_GREEN: '#008000',
    STATUSES_VIOLET: '#ee82ee',
    STATUSES_BLUE: '#0000ff',
    STATUSES_ORANGE: '#ffa500',
    STATUSES_RED: '#ff0000',
    STATUSES_BLACK: '#000000',
    STATUSES_WHITE: '#ffffff',
  },
  animations: {
    defaultState: {
      transition: `opacity 300ms ease-in-out`,
      opacity: 0,
    },
    reverseDefaultState: {
      transition: `opacity 300ms ease-in-out`,
      opacity: 1,
    },
    defaultSteps: {
      entered: { display: 'flex', opacity: 1 },
      exiting: { opacity: 0 },
      exited: { display: 'none', opacity: 0 },
    },
    slideState: {
      transition: `all 300ms ease-in-out`,
      opacity: 0,
      maxHeight: 0,
    },
    slideSteps: {
      entered: { opacity: 1, maxHeight: 'inherit' },
      exiting: { opacity: 0, maxHeight: 0 },
      exited: { opacity: 0 },
    },
    opacity: keyframes`
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    `,
    slide: {
      sidebar: keyframes`
        65% {
          right: 30px;
        }
        80% {
          right: 10px;
        }
        100% {
          right: 22px;
        }
      `,
      modal: keyframes`
        0% {
          transform: translateY(-100px);
        }
        65% {
          transform: translateY(10px);
        }
        80% {
          transform: translateY(-10px);
        }
        100% {
          transform: translateY(0);
        }
      `,
      modalRB: keyframes`
        0% {
          transform: translate(100px, 100px);
        }
        100% {
          transform: translate(0, 0);
        }
      `,
    },
    preload: keyframes`
      0% {
        transform: none;
      }
      100% {
        transform: translate(10px, 0);
      }
    `,
    rotate: keyframes`
      0% {
        transform: rotate(-90deg);
      }
      25% {
        transform: rotate(0);
      }
      50% {
        transform: rotate(90deg);
      }
      75% {
        transform: rotate(180deg);
      }
      100% {
        transform: rotate(270deg);
      }
    `,
  },
};

export default defaultTheme;
